<template>
<div class="w-85per dp-inblock">
    <div class="title">
        <h2>팝업 설정</h2>
    </div>
    <div class="agree-box">
        <input type="text" v-model="popupTitle" class="w-100per mb-20" maxlength="23" @keyup="checkTitle()" placeholder="팝업 제목 입력해주세요. (20자 이내)">
        <ckeditor :parentData="popupContents" v-model="popupContents"></ckeditor>
    </div>
    <div class="line"></div>
    <div class="mt-30 w-100per mg-auto">
        <button @click="prev()" class="admin-btn-default">이전</button>
        <button @click="finish()" class="admin-btn-default float-right ml-05">완료하기</button>
        <button @click="save()" class="admin-btn-default float-right ml-05">저장</button>
        <button @click="preview()" class="admin-btn-default float-right" data-toggle="modal" data-target="#preview_pop">미리보기</button>
    </div>
    <preview-modal v-if="isModalOpened" :isModalOpened="isModalOpened" :titleContent="popupTitle" :editorContent="popupContents" @close="closeModal"></preview-modal>
</div>
</template>

<script>
import PreviewModal from '@/components/reg/setPopup/previewModal.vue'
import Ckeditor from '@/components/utils/ckEditor.vue'
export default {
    data: () => ({
        popupContents: '', // 에디터 default 내용
        popupTitle: '', // 팝업설정 타이틀명
        isModalOpened: false,

        isSaved: false // 저장 여부
    }),
    components: {
        PreviewModal,
        Ckeditor
    },

    mounted() {
        if (sessionStorage.getItem('fix')) {
            var mainIdx = sessionStorage.getItem('mainIdx')
            var params = {
                mainIdx: mainIdx
            }
            this.axios.get(this.axios.root + this.axios.port + `/sugang/popup/${mainIdx}`, params)
                .then(res => {
                    console.log('res', res)
                    this.popupContents = res.data.popup.popup_contents
                    this.popupTitle = res.data.popup.popup_title
                }).catch(err => {
                    console.log(err)
                    alert(err)
                })
        }
    },

    methods: {
        // 팝업 타이틀 20자 초과일때 alert
        checkTitle() {
            if (this.popupTitle.length > 20) {
                this.popupTitle = this.popupTitle.substring(0, 20);
                alert("팝업 제목은 20자 이내로 입력해주세요.");
                return false;
            }
        },

        // 이전 페이지 이동
        prev() {
            var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
            var idx = pOrder.indexOf('setPopup') - 1
            this.$router.push(`/admin/reg/${pOrder[idx]}`)
            // this.$router.push('/admin/reg/purchase')
        },

        // 최종 저장하기
        save() {
            if (this.popupTitle.trim() === '') {
                alert('팝업 제목을 입력해주세요.')
                return false
            } else if (this.popupContents.trim() === '') {
                alert('팝업 내용을 입력해주세요.')
                return false
            } else {
                var params = {
                    mainIdx: sessionStorage.getItem('mainIdx'),
                    popupTitle: this.popupTitle,
                    popupContents: this.popupContents
                }

                this.axios.put(this.axios.root + this.axios.port + '/sugang/popup', params)
                    .then(res => {
                        console.log('res', res)
                        if (res.data.err === 0) {
                            this.isSaved = true
                            alert('저장되었습니다.')
                        }
                    })
                // this.$router.push('/admin/list')
            }
        },

        // 팝업 설정 미리보기
        preview() {
            if (!this.isSaved) {
                alert('미리보기를 하려면 먼저 저장을 해야합니다.')
                return false
            } else {
                this.isModalOpened = true
            }
        },

        // 완료하고 수강신청 관리 페이지로 redirect
        finish() {
            if (this.isSaved) {
                alert('수강신청 등록이 완료되었습니다.')
                this.$router.push('/admin/list/main')
            } else {
                alert('저장을 먼저 해주세요.')
                return false
            }
        },

        // 미리보기 레이어팝업 닫기
        closeModal() {
            this.isModalOpened = false
        }
    }
}
</script>
